import { render, staticRenderFns } from "./BaseOutlinedButton.vue?vue&type=template&id=31777cb5"
import script from "./BaseOutlinedButton.vue?vue&type=script&lang=js"
export * from "./BaseOutlinedButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports